// Customer-side mapping page — Tricivo customer → QB customer.

import { QuickBooksMappingPage } from './QuickBooksMappingPage';

export function QuickBooksCustomerMappingPage(): JSX.Element {
  return (
    <QuickBooksMappingPage
      kind="customer"
      title="QuickBooks customer mappings"
      subtitle="Map Tricivo customers to QuickBooks customers."
      fieldLabel="Customer name"
    />
  );
}
